import Swiper, {Navigation} from 'swiper';

const sliderInit = () => {
	const eventSlider = document.querySelector('.event__container');
	const formatSlider = document.querySelector('.format__container');

	const eventSwiper = new Swiper(eventSlider, {
		speed: 700,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Navigation],
		navigation: {
			prevEl: '.event__arrow--prev',
			nextEl: '.event__arrow--next',
		},
	});

	const formatSwiper = new Swiper(formatSlider, {
		speed: 700,
		spaceBetween: 0,
		slidesPerView: 'auto',
		breakpoints: {
			768: {
				enabled: false,
			},
		},
	});
};

export default sliderInit;
